import { render, staticRenderFns } from "./UserEditFormulaModal.vue?vue&type=template&id=1ab003fa&scoped=true&"
import script from "./UserEditFormulaModal.vue?vue&type=script&lang=js&"
export * from "./UserEditFormulaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab003fa",
  null
  
)

export default component.exports